import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragEx, Anlage } from 'src/app/api/model/model';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { FileHelper } from 'src/app/api/helper/file-helper';
import { MyApp } from 'src/app/api/helper/app';
import { SystemService } from 'src/app/api/system.service';

@Component({
    selector: 'app-auftrag-dateien',
    templateUrl: './auftrag-dateien.component.html',
    styleUrls: ['./auftrag-dateien.component.scss'],
    standalone: false
})
export class AppAuftragDateienComponent implements OnInit, OnDestroy, AfterViewInit {
    log = new Logger('AppAuftragDateienComponent');

    subscriptions: Subscription[] = [];

    @Input() auftrag: AuftragEx = null;

    dateien: AnlageVO[] = null;

    isVisible = false;

    constructor(
        private fileOpener: FileOpener,
        private cdr: ChangeDetectorRef,
        private systemService: SystemService) { }

    async ngOnInit() {
        if (this.auftrag && this.auftrag.Anlagen) {
            this.dateien = this.auftrag.Anlagen as AnlageVO[];

            for (const datei of this.dateien) {
                datei.icon = FileHelper.getFileIcon(datei.MimeType);
            }
        }
    }

    async ngAfterViewInit() {
        this.log?.info('ngAfterViewInit');
    }

    ngOnDestroy() {
    }

    async ionViewWillEnter() {
    }

    ionViewDidEnter() {
    }

    ionViewWillLeave() {
    }

    isPdf(p: Anlage) {
        return p.MimeType == "application/pdf";
    }

    isDocument(p: Anlage) {
        return !this.isPdf(p);
    }

    async onItemClicked(e: Event, p: AnlageVO) {
        ClickHelper.click(e, () => this.doItemClicked(p));
    }

    async doItemClicked(p: AnlageVO) {
        if (p.Pfad) {
            if (!MyApp.isCordovaAvailable()) {
                UiHelper.showAlert('Funktion im Browser nicht verfügbar');
                return;
            }

            let directory = MyApp.getDownloadDirectory();

            const fileExists = await FileHelper.checkFileExists(directory, p.LocalPfad);

            if (!fileExists) {
                let guid = p.Guid;

                if (!guid) {
                    this.log.error('Daten fehlerhaft. Download nicht möglich', p);
                    await UiHelper.showLoading('Daten fehlerhaft. Download nicht möglich');
                    return;
                }

                await UiHelper.showLoading('Wird geladen...');

                try {
                    // Datei wurde nicht nocht heruntergeladen. jetzt laden
                    await this.systemService.downloadFile({
                        filename: p.Dateiname,
                        status: 0,
                        guid,
                        size: p.Size,
                        errorCount: 0,
                        filePath: p.LocalPfad
                    });

                    await UiHelper.hideLoading();
                } catch (err) {
                    await UiHelper.hideLoading();
                    await UiHelper.showError(err);
                    return;
                }
            }

            try {
                await this.fileOpener.open(p.Pfad, p.MimeType);
            } catch (err) {
                this.log.error('Fehler beim Öffnen der Datei: ' + p.Pfad, err);
                UiHelper.showError('Fehler beim Öffnen der Datei: ' + p.Pfad);
            }
        }
    }
}

interface AnlageVO extends Anlage {
    icon: string;
}
